import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Auto-reload on stale chunk references (typically after a deploy that
// regenerated webpack hashes while a tab still holds the old main bundle).
const RELOAD_KEY = 'ml_chunk_reload_at';
function isChunkLoadError(err) {
  if (!err) return false;
  const msg = (err && (err.message || String(err))) || '';
  return err.name === 'ChunkLoadError' || /Loading chunk \d+ failed/i.test(msg) || /Loading CSS chunk/i.test(msg);
}
function maybeReload(err) {
  if (!isChunkLoadError(err)) return;
  // Avoid reload loops: only once per 10s.
  const last = parseInt(sessionStorage.getItem(RELOAD_KEY) || '0', 10);
  if (Date.now() - last < 10000) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
}
window.addEventListener('error', (e) => maybeReload(e.error || e));
window.addEventListener('unhandledrejection', (e) => maybeReload(e.reason));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
